import { render } from "./humm-widget.vue?vue&type=template&id=2605b4be&scoped=true"
import script from "./humm-widget.vue?vue&type=script&lang=js"
export * from "./humm-widget.vue?vue&type=script&lang=js"

import "./humm-widget.vue?vue&type=style&index=0&id=2605b4be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2605b4be"]])

export default __exports__